export * as appPlans from '@wix/auto_sdk_app-management_app-plans/schemas';
export * as appInstances from '@wix/auto_sdk_app-management_app-instances/schemas';
export * as appPermissions from '@wix/auto_sdk_app-management_app-permissions/schemas';
export * as biEvents from '@wix/auto_sdk_app-management_bi-events/schemas';
export * as billing from '@wix/auto_sdk_app-management_billing/schemas';
export * as embeddedScripts from '@wix/auto_sdk_app-management_embedded-scripts/schemas';
export * as externalBilling from '@wix/auto_sdk_app-management_external-billing/schemas';
